// extracted by mini-css-extract-plugin
module.exports = {"container":"AddButton__container___0CsUl","iconPlus":"AddButton__iconPlus___kEjhC"};